import { Button } from 'ui/components/Buttons'
import { Page } from 'ui/components/Page'

import { ClientUsersTable } from './components/ClientUsersTable'
import { CreateUserDialog } from './components/CreateUserDialog'
import { useClientUsersListContext } from './context/ClientUsersListContext'
import { ClientUsersListContextProvider } from './context/ClientUsersListContextProvider'
import { useClientUserEdit } from './hooks'

const ClientUsers = () => {
  const { data } = useClientUsersListContext()

  const {
    isEditClientUserDialogOpen,
    openEditClientUserDialog,
    closeEditClientUserDialog,
    clientUserForEditing,
    setClientUserForEditing,
    RemoveClientUserConfirmation,
    openRemoveClientUserConfirmation,
    sendInviteLink
  } = useClientUserEdit()

  const showCreateUserDialog = isEditClientUserDialogOpen || !!clientUserForEditing

  return (
    <Page
      title="Client Users & Permissions"
      actions={
        data?.enableAddNew && (
          <Button face="tertiary" onClick={openEditClientUserDialog}>
            Add New
          </Button>
        )
      }
    >
      {showCreateUserDialog && (
        <CreateUserDialog
          onClose={closeEditClientUserDialog}
          clientUserForEditing={clientUserForEditing}
          permissionsStructure={data?.permissions}
          relationshipsToAssign={data?.relationshipsToAssign}
        />
      )}
      <RemoveClientUserConfirmation />
      <ClientUsersTable
        setEditClientUser={setClientUserForEditing}
        setRemovingClientUser={openRemoveClientUserConfirmation}
        sendInviteLink={sendInviteLink}
      />
    </Page>
  )
}

const ClientUsersWrapper = () => (
  <ClientUsersListContextProvider>
    <ClientUsers />
  </ClientUsersListContextProvider>
)

export default ClientUsersWrapper
